// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./coreStyles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./filterStyles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./mediaStyles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --nick-orange: 236, 101, 0;
  --nick-green: 128, 255, 0;
}


.no-display {
  display: none !important;
}

@keyframes animateDots {
  0%, 20% {
    content: '.';
  }
  40%, 60% {
    content: '..';
  }
  80%, 100% {
    content: '...';
  }
}

.animated-dots::after {
  content: '.';
  animation: animateDots 1.4s infinite;
  display: inline-block;
  width: 1.2em;
  text-align: left;
}

/* full body blur */
body:has(dialog[open]) {
  filter: blur(2px) saturate(60%);
}

/* disable text selection */
.prevent-select {
  -moz-user-select:none; /* firefox */
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

/* remove scroll bars */
.no-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* webkit - remove scroll bars */
.no-scroll::-webkit-scrollbar {
  display: none;
}

/* ================================ LAYOUT ================================= */
#app-root-container {
  height: 100vh;
  margin: -8px;
  display: flex;
  flex-direction: column;
}

#nala-primary-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

#nala-header-layout {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: .05;
  width: 100%;
}

#header-nav-container {
  flex: 1;
  margin: 0 0 0 8px;
}

#header-logo-container {
  display: flex;
  justify-content: center;
  margin: 0 8px;
}

#header-account-container {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  margin: 0 8px 0 0;
}

#header-logo {
  display: block;
  width: 80px;
  height: auto;
  filter: drop-shadow(1px 3px 2px rgba(12, 17, 26, 0.25));
}

#active-folder-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 8px;  
}

.horizontal-divider {
  height: .085rem;  
  margin: 3px 2px;
  border-radius: 4px;
}

.vertical-divider {
  width: 2px;
  min-width: 2px;
  max-width: 2px;
  flex-shrink: 0;
  flex-basis: 2px;
  align-self: stretch;
  margin: 3px 2px;
  border-radius: 4px;
}

.hide-me
{
  visibility: hidden;
  pointer-events: none;
}

/* ============================== END LAYOUT =============================== */
/* ================================= LOGIN ================================= */
.login-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  height: 100vh;
}

#login-icon {
  display: block;
  width: 200px;
  height: auto;
}

.icon-light {
  filter: drop-shadow(0 0 24px rgba(3, 11, 45, 0.4)) drop-shadow(0 4px 10px rgba(0,0,0,0.25))
}


/* ================================ NAVBAR ================================= */
#nala-nav-primary-layout {
  display: flex;
  flex: .05;
  justify-content: space-between;
  align-items: center;
  width: 100%;  
}

#nav-core-container {
  display: flex;
  gap: 12px;
  padding: 8px;
  min-height: 55px;
}
/* ============================== END NAVBAR =============================== */`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAKA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;AACjC;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB,EAAE,YAAY;EACnC,yBAAyB,EAAE,WAAW;EACtC,qBAAqB,EAAE,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA,uBAAuB;AACvB;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,8EAA8E;AAC9E,8EAA8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;AACF;;;AAGA,8EAA8E;AAC9E;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;AACA,8EAA8E","sourcesContent":["@import './coreStyles.css';\n@import './filterStyles.css';\n@import './mediaStyles.css';\n\n\n:root {\n  --nick-orange: 236, 101, 0;\n  --nick-green: 128, 255, 0;\n}\n\n\n.no-display {\n  display: none !important;\n}\n\n@keyframes animateDots {\n  0%, 20% {\n    content: '.';\n  }\n  40%, 60% {\n    content: '..';\n  }\n  80%, 100% {\n    content: '...';\n  }\n}\n\n.animated-dots::after {\n  content: '.';\n  animation: animateDots 1.4s infinite;\n  display: inline-block;\n  width: 1.2em;\n  text-align: left;\n}\n\n/* full body blur */\nbody:has(dialog[open]) {\n  filter: blur(2px) saturate(60%);\n}\n\n/* disable text selection */\n.prevent-select {\n  -moz-user-select:none; /* firefox */\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n\n/* remove scroll bars */\n.no-scroll {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n/* webkit - remove scroll bars */\n.no-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n/* ================================ LAYOUT ================================= */\n#app-root-container {\n  height: 100vh;\n  margin: -8px;\n  display: flex;\n  flex-direction: column;\n}\n\n#nala-primary-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\n\n#nala-header-layout {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex: .05;\n  width: 100%;\n}\n\n#header-nav-container {\n  flex: 1;\n  margin: 0 0 0 8px;\n}\n\n#header-logo-container {\n  display: flex;\n  justify-content: center;\n  margin: 0 8px;\n}\n\n#header-account-container {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  margin: 0 8px 0 0;\n}\n\n#header-logo {\n  display: block;\n  width: 80px;\n  height: auto;\n  filter: drop-shadow(1px 3px 2px rgba(12, 17, 26, 0.25));\n}\n\n#active-folder-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;  \n}\n\n.horizontal-divider {\n  height: .085rem;  \n  margin: 3px 2px;\n  border-radius: 4px;\n}\n\n.vertical-divider {\n  width: 2px;\n  min-width: 2px;\n  max-width: 2px;\n  flex-shrink: 0;\n  flex-basis: 2px;\n  align-self: stretch;\n  margin: 3px 2px;\n  border-radius: 4px;\n}\n\n.hide-me\n{\n  visibility: hidden;\n  pointer-events: none;\n}\n\n/* ============================== END LAYOUT =============================== */\n/* ================================= LOGIN ================================= */\n.login-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  height: 100vh;\n}\n\n#login-icon {\n  display: block;\n  width: 200px;\n  height: auto;\n}\n\n.icon-light {\n  filter: drop-shadow(0 0 24px rgba(3, 11, 45, 0.4)) drop-shadow(0 4px 10px rgba(0,0,0,0.25))\n}\n\n\n/* ================================ NAVBAR ================================= */\n#nala-nav-primary-layout {\n  display: flex;\n  flex: .05;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;  \n}\n\n#nav-core-container {\n  display: flex;\n  gap: 12px;\n  padding: 8px;\n  min-height: 55px;\n}\n/* ============================== END NAVBAR =============================== */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
